<template>
  <ReCruiseModal :showModal="showModal" @update:showModal="updateShowModal">
    <template #header="{ closeModal }">
      <div class="modal-header">
        <button @click="goBack">
          <img src="@/assets/images/icon/arrow_left_navigation_icon.svg" alt="icon" />
        </button>

        <div class="modal-title">{{ $t('panstarPay.addCard') }}</div>

        <button class="close-button" @click="closeModal">
          <img src="@/assets/images/icon/close_icon.svg" alt="icon" />
        </button>
      </div>
    </template>

    <template #content>
      <div class="register-container">
        <div class="card-type-field">
          <ReCruiseRadio
            v-model="userType"
            value="0"
            name="cardType"
            :label="$t('panstarPay.personalCard')"
            @onChange="handleCertType('0')"
          />

          <ReCruiseRadio
            v-model="userType"
            value="1"
            name="cardType"
            :label="$t('panstarPay.corporateCard')"
            @onChange="handleCertType('0')"
          />

          <!-- <ReCruiseRadio
            v-model="certType"
            value="3"
            name="cardType"
            :label="$t('panstarPay.overseasCard')"
            @onChange="handleUserType(null)"
          /> -->
        </div>

        <template v-if="!isInternationalCard">
          <CruiseInputField v-if="userType === '0'" :label="$t('profile.dateOfBirth')" required>
            <ReCruiseInput v-model="authValue" placeholder="YYMMDD" maxLength="6" :regexFilter="regExp.notNumber" />
          </CruiseInputField>

          <CruiseInputField v-else :label="$t('footer.companyInfo.registrationNumbers')" required>
            <ReCruiseInput
              v-model="registrationNumber"
              :placeholder="$t('panstarPay.businessRegistrationNumberLength')"
              maxLength="10"
              :regexFilter="regExp.notNumber"
            />
          </CruiseInputField>
        </template>

        <div class="card-field">
          <div class="card-number-title">
            <CruiseLabel class="card-number-label" :label="$t('panstarPay.cardNumber')" required />
            <span class="alert-text">{{ $t('panstarPay.debitCardNotAllowed') }}</span>
          </div>

          <form class="card-number-wrapper">
            <ReCruiseInput
              class="card-number"
              v-model="card1"
              placeholder="****"
              maxLength="4"
              :regexFilter="regExp.notNumber"
            />
            <span class="divider-dash">-</span>
            <ReCruiseInput
              class="card-number"
              v-model="card2"
              placeholder="****"
              maxLength="4"
              :regexFilter="regExp.notNumber"
            />
            <span class="divider-dash">-</span>
            <ReCruiseInput
              class="card-number"
              v-model="card3"
              placeholder="****"
              maxLength="4"
              :regexFilter="regExp.notNumber"
            />
            <span class="divider-dash">-</span>
            <ReCruiseInput
              class="card-number"
              v-model="card4"
              placeholder="****"
              maxLength="4"
              :regexFilter="regExp.notNumber"
            />
          </form>
        </div>

        <CruiseInputField :label="$t('panstarPay.expiryDate')" required>
          <div class="card-info-field">
            <ReCruiseInput
              class="card-number"
              v-model="expiryMonth"
              placeholder="MM"
              maxLength="2"
              :regexFilter="regExp.notNumber"
            />
            <ReCruiseInput
              class="card-number"
              v-model="expiryYear"
              placeholder="YY"
              maxLength="2"
              :regexFilter="regExp.notNumber"
            />
          </div>
        </CruiseInputField>

        <CruiseInputField v-if="!isInternationalCard" :label="$t('panstarPay.password')" required>
          <ReCruiseInput
            v-model="password"
            :placeholder="$t('panstarPay.passwordPlaceholder')"
            maxLength="2"
            :regexFilter="regExp.notNumber"
          />
        </CruiseInputField>

        <!-- <ReCruiseCheckbox
          v-if="cardList.length !== 0"
          class="main-checkbox"
          v-model="isInVesselPurchaseCard"
          :label="$t('panstarPay.registerOnboardCard')"
          :disabled="cardList.length === 0 || isApp"
        /> -->
      </div>
    </template>

    <template #button>
      <ReCruiseButton class="mobile-btn" @click="goBack">{{ $t('actions.prev') }}</ReCruiseButton>
      <ReCruiseButton class="pc-btn" theme="outline" @click="updateShowModal(false)">
        {{ $t('actions.close') }}
      </ReCruiseButton>
      <ReCruiseButton class="register-btn" @click="registerPanstarPay">{{ $t('actions.register') }}</ReCruiseButton>
    </template>
  </ReCruiseModal>
</template>

<script>
import dayjs from '@/utils/dayjsConfig';
import { mapState } from 'vuex';
import { YYYYMMDD } from '@/const/const';
import PaymentService from '@/services/payment';
import { regExp } from '@/utils/validator';

import ReCruiseModal from '@/components/renewal/modal/ReCruiseModal.vue';
import ReCruiseButton from '@/components/renewal/button/ReCruiseButton.vue';
import ReCruiseInput from '@/components/renewal/common/ReCruiseInput.vue';
import CruiseInputField from '@/components/common/CruiseInputField.vue';
import CruiseLabel from '@/components/common/CruiseLabel.vue';
import ReCruiseCheckbox from '@/components/renewal/common/ReCruiseCheckbox.vue';
import ReCruiseRadio from '@/components/renewal/common/ReCruiseRadio.vue';

export default {
  name: 'PanstarPayRegister',
  components: {
    ReCruiseModal,
    ReCruiseInput,
    ReCruiseButton,
    CruiseInputField,
    CruiseLabel,
    ReCruiseCheckbox,
    ReCruiseRadio,
  },
  emits: ['update:showModal', 'onRegisterPanstarPay'],
  props: {
    showModal: { type: Boolean, required: true },
    goToStep: Function,
    goBack: Function,
    cardList: Array,
  },
  data() {
    return {
      step: 'register',
      regExp,
      certType: '0', // 0 : 개인/법인, 3 : 해외
      userType: '0', // 0 : 개인, 1 : 법인
      authValue: '',
      registrationNumber: '',
      card1: '',
      card2: '',
      card3: '',
      card4: '',
      isInVesselPurchaseCard: this.cardList.length === 0 ? true : false,
      expiryMonth: '',
      expiryYear: '',
      password: '',
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    isMobile() {
      return /Mobi|iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    },
    deviceTypeCode() {
      const DIRECT_PC = 'N8';
      const DIRECT_MOBILE = 'D8';
      return this.isMobile ? DIRECT_MOBILE : DIRECT_PC;
    },
    OSTypeCode() {
      const userAgent = window.navigator.userAgent;

      // 모바일 OS 판별
      if (/Android/i.test(userAgent)) return 'AN';
      if (/iPhone|iPad|iPod/i.test(userAgent)) return 'IO';

      // 데스크톱 OS 판별
      if (/Win/i.test(userAgent)) return 'WI';
      if (/Mac/i.test(userAgent)) return /Mobi/i.test(userAgent) ? 'IO' : 'MA';

      // 기타
      return 'ET';
    },
    clientVersion() {
      /**
       * 클라이언트 버전(2 자리) + OS 구분(2 자리),
       * 클라이언트 버전 -> N8 : 다이렉트 PC, D8 : 다이렉트 모바일
       * OS 버전 -> WI : 윈도우, AN : 안드로이드, IO : ios, MA : 매킨토시, ET : 기타 OS
       */
      return `${this.deviceTypeCode}${this.OSTypeCode}`;
    },
    cardNumber() {
      return `${this.card1}${this.card2}${this.card3}${this.card4}`;
    },
    expireDate() {
      return `${this.expiryYear}${this.expiryMonth}`;
    },
    isInternationalCard() {
      return this.certType === '3';
    },
    isApp() {
      return this.$route.fullPath.includes('app');
    },
  },
  // watch: {
  //   cardList: {
  //     immediate: true,
  //     handler() {
  //       this.isInVesselPurchaseCard = this.cardList.length === 0 || !this.cardList || this.isApp ? true : false;
  //     },
  //   },
  // },
  methods: {
    updateShowModal(value) {
      this.$emit('update:showModal', value);
    },
    generateShopOrderNo() {
      const PAY = 'PAY'; // Admin
      const DEVICE = this.isMobile ? 'P' : 'M';
      const PG = 'KC'; // KC: KICC

      return `${PAY}${DEVICE}${PG}${this.generateUniqueOrderNumber()}`;
    },
    generateUniqueOrderNumber() {
      const datePart = dayjs().format('YYYYMMDDHHmmssSS');
      const randomPart = this.generateRandomCode();
      return `${datePart}${randomPart}`;
    },
    generateRandomCode() {
      const digits = '0123456789';
      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const chars = digits + letters;

      let result = '';
      for (let i = 0; i < 4; i++) {
        result += chars[Math.floor(Math.random() * chars.length)];
      }
      return result;
    },
    validRegister() {
      if (this.cardNumber.length < 13) {
        this.$alert({ content: this.$t('messages.cardNumber') });
        return false;
      }

      if (this.expiryMonth.length !== 2 || this.expiryYear.length !== 2) {
        this.$alert({ content: this.$t('messages.cardExpiration') });
        return false;
      }

      if (this.certType === '0') {
        if (this.userType === '0') {
          // 개인 카드
          if (this.authValue.length !== 6) {
            this.$alert({ content: this.$t('messages.enterBitrh') });
            return false;
          }
        } else {
          // 법인 카드
          if (this.registrationNumber.length !== 10) {
            this.$alert({ content: this.$t('messages.businessRegistrationNumber') });
            return false;
          }
        }

        if (this.password.length !== 2) {
          this.$alert({ content: this.$t('messages.cardPassword') });
          return false;
        }
      }

      return true;
    },
    // 팬스타페이 카드 등록(빌키 발급) 로직
    async registerPanstarPay() {
      if (!this.validRegister()) return;

      try {
        const token = this.$route.query.token;
        const params = {
          directCommonInfo: {
            mallId: '05590035', // KICC mallId
            currency: '00', // 00: KRW
            amount: 0, // 빌키 발급시 0
            clientVersion: this.clientVersion,
          },
          directOrderInfo: {
            shopOrderNo: this.generateShopOrderNo(), // 주문에 대하여 유일값이여야한다.
            customerNo: String(this.user?.id), // cruiseUserID
            customerId: this.user?.userId, // 팬스타크루즈 로그인 아이디
            customerName: this.user?.name, // 고객명
            customerMail: this.user?.email, // 고객 이메일
            customerContactNo1: this.user?.mobile, // 고객 연락처1
            goodsName: this.$t('panstarPay.panstarPay'), // 상품명
            goodsAmount: 0, // 빌키 발급시 0
            value2: dayjs(this.user?.birthDay).format(YYYYMMDD), // 생년월일 8자리
            value4: this.user?.sex, // 성별 M : 남성, F : 여성
          },
          directCardInfo: {
            cardTxtype: '11', // 11 : 배치키(빌키)발급
            certType: this.certType, // 0 : 일반, 3 : 카드번호,유효기간(빌키발급 해외카드일 경우) ! 빌키 발급시 필수
            cardAmount: 0, // 빌키 발급시 0
            cardNo: this.cardNumber, // 배치키(빌키) 발급시 : 결제할 카드번호
            ...(this.certType !== '3' && { password: this.password }), // 카드 비밀번호 앞 2 자리
            ...(this.certType !== '3' && { userType: this.userType }), // 개인: 0, 법인: 1
            ...(this.certType !== '3' && {
              authValue: this.userType === '0' ? this.authValue : this.registrationNumber,
            }), // 개인: 생년월일 6자리, 법인: 사업자번호 10자리
            expiryDate: this.expireDate, // 카드 유효기간(년 2 자리 + 월 2 자리)
          },
          // isInVesselPurchaseCard: this.cardList.length === 0 ? true : this.isInVesselPurchaseCard, // 선내구매 여부
          isInVesselPurchaseCard: true, // 선내구매 여부
        };

        await PaymentService.registerPanstarPayByEasypay(params, token);
        this.clearState();

        if (this.$route.fullPath.includes('app')) {
          this.$router.push('/app/redirect');
        } else {
          this.goToStep('complete');
        }

        this.$emit('onRegisterPanstarPay');
      } catch (error) {
        this.$alert({ content: error });
      }
    },
    clearState() {
      this.card1 = '';
      this.card2 = '';
      this.card3 = '';
      this.card4 = '';
      this.expiryMonth = '';
      this.expiryYear = '';
      this.password = '';
      this.authValue = '';
      this.registrationNumber = '';
      this.isInVesselPurchaseCard = this.cardList.length === 0 ? true : false;
    },
    handleCertType(certType) {
      this.certType = certType;
    },
    handleUserType(userType) {
      this.userType = userType;
    },
  },
  deactivated() {
    this.clearState();
  },
};
</script>

<style scoped>
.modal-header {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  color: var(--Grey-grey-900, #333);
  font-family: 'Pretendard';
  font-size: 20px;
  font-weight: 600;
}

.register-container {
  color: var(--Grey-grey-900, #333);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card-type-field {
  display: flex;
  gap: 10px;
}

.card-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-number-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-number-label {
  color: var(--Grey-grey-900, #333);
  font-family: 'Pretendard';
  font-size: 14px;
  font-weight: 500;
}

.alert-text {
  color: var(--Red, #ff0000);
  font-family: 'Pretendard';
  font-size: 12px;
  font-weight: 400;
}

.card-number-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.card-number {
  flex: 1 0;
}

.card-info-field {
  display: flex;
  gap: 12px;
}

.divider-dash {
  color: var(--Black, #000);
  font-size: 14px;
  font-weight: 400;
}

.main-checkbox {
  margin-top: 4px;
}

.mobile-btn {
  display: initial;
  width: 100%;
  border-radius: 0;
  background: var(--Grey-grey-50);
  color: var(--Grey-grey-500, var(--Disabled));
}

.mobile-btn:hover {
  background: var(--Grey-grey-100);
  color: var(--Grey-grey-700);
}

.pc-btn {
  display: none;
}

.register-btn {
  width: 100%;
  border-radius: 0;
}

@media screen and (min-width: 768px) {
  .mobile-btn {
    display: none;
  }

  .pc-btn {
    display: initial;
  }

  .register-btn {
    width: 200px;
    border-radius: 5px;
  }
}
</style>
